import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import Lottie from "react-lottie";
import * as animationData from "../../assets/lottie/Success.json";
const SuccessModel = ({
  show,
  setShow,
  name = "Operation was successfull!",
}) => {
  useEffect(() => {
    setShow(true);
    const timer = setTimeout(() => {
      setShow(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Modal show={show} onHide={() => setShow(false)} centered>
      <Modal.Body className="text-center">
        <div className="success-gif">
          <Lottie
            className="success-lottie me-auto"
            width={100}
            options={defaultOptions} // Your Lottie JSON animation data
          />
        </div>
        <div style={{ color: "green", marginTop: "15px" }}>
          <h5>{name}</h5>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SuccessModel;
